export default __webpack_public_path__ + "static/media/1963-desktop.993ed8a5.jpg";